import(/* webpackMode: "eager" */ "/vercel/path0/app/client-error-handler.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/datadog-init.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/dynamicScripts.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Atoms/CustomToastContainer/CustomToastContainer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Atoms/Popups/UserDetailsModal/UserDetailsModal.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Atoms/SessionWrapper/SessionWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Atoms/VisibilityWrapper/VisibilityWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Atoms/WhatsApp/WhatsApp.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Molecules/NewFooterSection/NewFooterSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Molecules/NewHeaderSection/HeaderContent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Organisms/App/AppSideEffects.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-calendar/dist/Calendar.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-clock/dist/Clock.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-date-picker/dist/DatePicker.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-time-picker/dist/TimePicker.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/slick-carousel/slick/slick-theme.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/fonts/index.js\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./poppins-v23-latin-300.woff2\",\"weight\":\"300\",\"style\":\"normal\"},{\"path\":\"./poppins-v23-latin-regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"./poppins-v23-latin-500.woff2\",\"weight\":\"500\",\"style\":\"normal\"}],\"variable\":\"--font-poppins\",\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/fonts/index.js\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./libre-baskerville-v16-latin-regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"}],\"variable\":\"--font-libre-baskerville\",\"display\":\"swap\"}],\"variableName\":\"libre_baskerville\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/fonts/index.js\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./almarai-v18-latin-300.woff2\",\"weight\":\"300\",\"style\":\"normal\"},{\"path\":\"./almarai-v18-latin-700.woff2\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"./almarai-v18-latin-regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"}],\"variable\":\"--font-almarai\",\"display\":\"swap\"}],\"variableName\":\"almarai\"}");
